import type { Component } from "svelte";
import type { SvelteHTMLElements } from "svelte/elements";
import CarbonRadioButtonChecked from "~icons/carbon/radio-button-checked";
import CifAd from "~icons/cif/ad";
import CifAe from "~icons/cif/ae";
import CifAf from "~icons/cif/af";
import CifAl from "~icons/cif/al";
import CifAm from "~icons/cif/am";
import CifAo from "~icons/cif/ao";
import CifAr from "~icons/cif/ar";
import CifAt from "~icons/cif/at";
import CifAu from "~icons/cif/au";
import CifAz from "~icons/cif/az";
import CifBd from "~icons/cif/bd";
import CifBe from "~icons/cif/be";
import CifBf from "~icons/cif/bf";
import CifBh from "~icons/cif/bh";
import CifBi from "~icons/cif/bi";
import CifBn from "~icons/cif/bn";
import CifBo from "~icons/cif/bo";
import CifBr from "~icons/cif/br";
import CifBt from "~icons/cif/bt";
import CifBw from "~icons/cif/bw";
import CifBy from "~icons/cif/by";
import CifBz from "~icons/cif/bz";
import CifCa from "~icons/cif/ca";
import CifCf from "~icons/cif/cf";
import CifCh from "~icons/cif/ch";
import CifCl from "~icons/cif/cl";
import CifCn from "~icons/cif/cn";
import CifCo from "~icons/cif/co";
import CifCr from "~icons/cif/cr";
import CifCu from "~icons/cif/cu";
import CifCv from "~icons/cif/cv";
import CifCy from "~icons/cif/cy";
import CifDe from "~icons/cif/de";
import CifDj from "~icons/cif/dj";
import CifDk from "~icons/cif/dk";
import CifDo from "~icons/cif/do";
import CifDz from "~icons/cif/dz";
import CifEc from "~icons/cif/ec";
import CifEg from "~icons/cif/eg";
import CifEr from "~icons/cif/er";
import CifEs from "~icons/cif/es";
import CifEt from "~icons/cif/et";
import CifFi from "~icons/cif/fi";
import CifFj from "~icons/cif/fj";
import CifFm from "~icons/cif/fm";
import CifFr from "~icons/cif/fr";
import CifGa from "~icons/cif/ga";
import CifGb from "~icons/cif/gb";
import CifGe from "~icons/cif/ge";
import CifGh from "~icons/cif/gh";
import CifGm from "~icons/cif/gm";
import CifGt from "~icons/cif/gt";
import CifGw from "~icons/cif/gw";
import CifGy from "~icons/cif/gy";
import CifHn from "~icons/cif/hn";
import CifHt from "~icons/cif/ht";
import CifId from "~icons/cif/id";
import CifIe from "~icons/cif/ie";
import CifIl from "~icons/cif/il";
import CifIn from "~icons/cif/in";
import CifIq from "~icons/cif/iq";
import CifIs from "~icons/cif/is";
import CifIt from "~icons/cif/it";
import CifJo from "~icons/cif/jo";
import CifJp from "~icons/cif/jp";
import CifKe from "~icons/cif/ke";
import CifKh from "~icons/cif/kh";
import CifKi from "~icons/cif/ki";
import CifKm from "~icons/cif/km";
import CifKw from "~icons/cif/kw";
import CifKz from "~icons/cif/kz";
import CifLa from "~icons/cif/la";
import CifLi from "~icons/cif/li";
import CifLk from "~icons/cif/lk";
import CifLr from "~icons/cif/lr";
import CifLs from "~icons/cif/ls";
import CifLu from "~icons/cif/lu";
import CifMa from "~icons/cif/ma";
import CifMc from "~icons/cif/mc";
import CifMd from "~icons/cif/md";
import CifMe from "~icons/cif/me";
import CifMg from "~icons/cif/mg";
import CifMh from "~icons/cif/mh";
import CifMl from "~icons/cif/ml";
import CifMn from "~icons/cif/mn";
import CifMr from "~icons/cif/mr";
import CifMt from "~icons/cif/mt";
import CifMv from "~icons/cif/mv";
import CifMw from "~icons/cif/mw";
import CifMx from "~icons/cif/mx";
import CifMy from "~icons/cif/my";
import CifMz from "~icons/cif/mz";
import CifNa from "~icons/cif/na";
import CifNe from "~icons/cif/ne";
import CifNg from "~icons/cif/ng";
import CifNi from "~icons/cif/ni";
import CifNl from "~icons/cif/nl";
import CifNo from "~icons/cif/no";
import CifNp from "~icons/cif/np";
import CifNr from "~icons/cif/nr";
import CifNu from "~icons/cif/nu";
import CifNz from "~icons/cif/nz";
import CifOm from "~icons/cif/om";
import CifPa from "~icons/cif/pa";
import CifPe from "~icons/cif/pe";
import CifPg from "~icons/cif/pg";
import CifPh from "~icons/cif/ph";
import CifPk from "~icons/cif/pk";
import CifPw from "~icons/cif/pw";
import CifPy from "~icons/cif/py";
import CifQa from "~icons/cif/qa";
import CifRu from "~icons/cif/ru";
import CifRw from "~icons/cif/rw";
import CifSa from "~icons/cif/sa";
import CifSb from "~icons/cif/sb";
import CifSc from "~icons/cif/sc";
import CifSe from "~icons/cif/se";
import CifSg from "~icons/cif/sg";
import CifSl from "~icons/cif/sl";
import CifSm from "~icons/cif/sm";
import CifSo from "~icons/cif/so";
import CifSr from "~icons/cif/sr";
import CifSt from "~icons/cif/st";
import CifSy from "~icons/cif/sy";
import CifSz from "~icons/cif/sz";
import CifTd from "~icons/cif/td";
import CifTh from "~icons/cif/th";
import CifTj from "~icons/cif/tj";
import CifTl from "~icons/cif/tl";
import CifTn from "~icons/cif/tn";
import CifTo from "~icons/cif/to";
import CifTv from "~icons/cif/tv";
import CifTz from "~icons/cif/tz";
import CifUa from "~icons/cif/ua";
import CifUg from "~icons/cif/ug";
import CifUs from "~icons/cif/us";
import CifUy from "~icons/cif/uy";
import CifUz from "~icons/cif/uz";
import CifVa from "~icons/cif/va";
import CifVe from "~icons/cif/ve";
import CifVn from "~icons/cif/vn";
import CifWs from "~icons/cif/ws";
import CifYe from "~icons/cif/ye";
import CifZa from "~icons/cif/za";
import CifZm from "~icons/cif/zm";
import CifZw from "~icons/cif/zw";
import FlowcodeCustomChartSize1x1 from "~icons/flowcode/custom-chart-size-1x1";
import FlowcodeCustomChartSize1x2 from "~icons/flowcode/custom-chart-size-1x2";
import FlowcodeCustomChartSize1x3 from "~icons/flowcode/custom-chart-size-1x3";
import FlowcodeCustomChartSize2x1 from "~icons/flowcode/custom-chart-size-2x1";
import FlowcodeCustomChartSize2x2 from "~icons/flowcode/custom-chart-size-2x2";
import FlowcodeCustomChartSize2x3 from "~icons/flowcode/custom-chart-size-2x3";
import FlowcodeFilterIcon from "~icons/flowcode/filter-icon";
import FlowcodeFolderSolid from "~icons/flowcode/folder-solid";
import FlowcodeQrCode from "~icons/flowcode/qr-code";
import FlowcodeReturnToStart from "~icons/flowcode/return-to-start";
import FlowcodeSixDotsVertical from "~icons/flowcode/six-dots-vertical";
import FlowcodeSubfilterIcon from "~icons/flowcode/subfilter-icon";
import FlowcodeTextComponent from "~icons/flowcode/text-component";
import FluentCheckboxChecked16Regular from "~icons/fluent/checkbox-checked-16-regular";
import FluentContentView16Regular from "~icons/fluent/content-view-16-regular";
import GgPoll from "~icons/gg/poll";
import GridiconsGrid from "~icons/gridicons/grid";
import GridiconsHeadingH1 from "~icons/gridicons/heading-h1";
import GrommetIconsSelect from "~icons/grommet-icons/select";
import GrommetIconsValidate from "~icons/grommet-icons/validate";
import HeroiconsAdjustmentsVertical from "~icons/heroicons/adjustments-vertical";
import HeroiconsArchiveBox from "~icons/heroicons/archive-box";
import HeroiconsArrowDown from "~icons/heroicons/arrow-down";
import HeroiconsArrowDownTray from "~icons/heroicons/arrow-down-tray";
import HeroiconsArrowLeft from "~icons/heroicons/arrow-left";
import HeroiconsArrowLeftOnRectangle from "~icons/heroicons/arrow-left-on-rectangle";
import HeroiconsArrowLongLeft from "~icons/heroicons/arrow-long-left";
import HeroiconsArrowLongRight from "~icons/heroicons/arrow-long-right";
import HeroiconsArrowPath from "~icons/heroicons/arrow-path";
import HeroiconsArrowRight from "~icons/heroicons/arrow-right";
import HeroiconsArrowRightCircle from "~icons/heroicons/arrow-right-circle";
import HeroiconsArrowRightOnRectangle from "~icons/heroicons/arrow-right-on-rectangle";
import HeroiconsArrowTopRightOnSquare from "~icons/heroicons/arrow-top-right-on-square";
import HeroiconsArrowTrendingDown from "~icons/heroicons/arrow-trending-down";
import HeroiconsArrowTrendingUp from "~icons/heroicons/arrow-trending-up";
import HeroiconsArrowTurnDownRight from "~icons/heroicons/arrow-turn-down-right";
import HeroiconsArrowUp from "~icons/heroicons/arrow-up";
import HeroiconsArrowUpTray from "~icons/heroicons/arrow-up-tray";
import HeroiconsBars2 from "~icons/heroicons/bars-2";
import HeroiconsBars3 from "~icons/heroicons/bars-3";
import HeroiconsBars3BottomLeft from "~icons/heroicons/bars-3-bottom-left";
import HeroiconsBeaker from "~icons/heroicons/beaker";
import HeroiconsBell from "~icons/heroicons/bell";
import HeroiconsBolt from "~icons/heroicons/bolt";
import HeroiconsBookOpen from "~icons/heroicons/book-open";
import HeroiconsBookmarkSquare from "~icons/heroicons/bookmark-square";
import HeroiconsBuildingOffice2 from "~icons/heroicons/building-office-2";
import HeroiconsBuildingStorefront from "~icons/heroicons/building-storefront";
import HeroiconsCalculator from "~icons/heroicons/calculator";
import HeroiconsCalendarDays from "~icons/heroicons/calendar-days";
import HeroiconsCamera from "~icons/heroicons/camera";
import HeroiconsChartBar from "~icons/heroicons/chart-bar";
import HeroiconsChartBarSquare from "~icons/heroicons/chart-bar-square";
import HeroiconsChatBubbleLeftEllipsis from "~icons/heroicons/chat-bubble-left-ellipsis";
import HeroiconsChatBubbleLeftRight from "~icons/heroicons/chat-bubble-left-right";
import HeroiconsCheck from "~icons/heroicons/check";
import HeroiconsCheckCircle from "~icons/heroicons/check-circle";
import HeroiconsChevronDoubleLeft from "~icons/heroicons/chevron-double-left";
import HeroiconsChevronDoubleRight from "~icons/heroicons/chevron-double-right";
import HeroiconsChevronDown from "~icons/heroicons/chevron-down";
import HeroiconsChevronLeft from "~icons/heroicons/chevron-left";
import HeroiconsChevronRight from "~icons/heroicons/chevron-right";
import HeroiconsChevronUp from "~icons/heroicons/chevron-up";
import HeroiconsChevronUpDown from "~icons/heroicons/chevron-up-down";
import HeroiconsCircleStack from "~icons/heroicons/circle-stack";
import HeroiconsClipboard from "~icons/heroicons/clipboard";
import HeroiconsClipboardDocument from "~icons/heroicons/clipboard-document";
import HeroiconsClipboardDocumentCheck from "~icons/heroicons/clipboard-document-check";
import HeroiconsClipboardDocumentList from "~icons/heroicons/clipboard-document-list";
import HeroiconsClock from "~icons/heroicons/clock";
import HeroiconsCloud from "~icons/heroicons/cloud";
import HeroiconsCloudArrowUp from "~icons/heroicons/cloud-arrow-up";
import HeroiconsCodeBracket from "~icons/heroicons/code-bracket";
import HeroiconsCodeBracketSquare from "~icons/heroicons/code-bracket-square";
import HeroiconsCog6Tooth from "~icons/heroicons/cog-6-tooth";
import HeroiconsCog8ToothSolid from "~icons/heroicons/cog-8-tooth-solid";
import HeroiconsCreditCard from "~icons/heroicons/credit-card";
import HeroiconsCurrencyDollar from "~icons/heroicons/currency-dollar";
import HeroiconsCursorArrowRaysSolid from "~icons/heroicons/cursor-arrow-rays-solid";
import HeroiconsCursorArrowRipple from "~icons/heroicons/cursor-arrow-ripple";
import HeroiconsCursorArrowRippleSolid from "~icons/heroicons/cursor-arrow-ripple-solid";
import HeroiconsDevicePhoneMobile from "~icons/heroicons/device-phone-mobile";
import HeroiconsDocument from "~icons/heroicons/document";
import HeroiconsDocumentDuplicate from "~icons/heroicons/document-duplicate";
import HeroiconsDocumentPlus from "~icons/heroicons/document-plus";
import HeroiconsDocumentText from "~icons/heroicons/document-text";
import HeroiconsEllipsisHorizontal from "~icons/heroicons/ellipsis-horizontal";
import HeroiconsEllipsisVertical from "~icons/heroicons/ellipsis-vertical";
import HeroiconsEnvelope from "~icons/heroicons/envelope";
import HeroiconsEquals from "~icons/heroicons/equals";
import HeroiconsExclamationCircle from "~icons/heroicons/exclamation-circle";
import HeroiconsExclamationTriangle from "~icons/heroicons/exclamation-triangle";
import HeroiconsEye from "~icons/heroicons/eye";
import HeroiconsEyeSlash from "~icons/heroicons/eye-slash";
import HeroiconsFolder from "~icons/heroicons/folder";
import HeroiconsFolderPlus from "~icons/heroicons/folder-plus";
import HeroiconsGlobeAlt from "~icons/heroicons/globe-alt";
import HeroiconsGlobeAmericas from "~icons/heroicons/globe-americas";
import HeroiconsHandRaised from "~icons/heroicons/hand-raised";
import HeroiconsHashtag from "~icons/heroicons/hashtag";
import HeroiconsHeart from "~icons/heroicons/heart";
import HeroiconsHeartSolid from "~icons/heroicons/heart-solid";
import HeroiconsHome from "~icons/heroicons/home";
import HeroiconsIdentification from "~icons/heroicons/identification";
import HeroiconsInformationCircle from "~icons/heroicons/information-circle";
import HeroiconsKey from "~icons/heroicons/key";
import HeroiconsLightBulb from "~icons/heroicons/light-bulb";
import HeroiconsLink from "~icons/heroicons/link";
import HeroiconsListBullet from "~icons/heroicons/list-bullet";
import HeroiconsLockClosed from "~icons/heroicons/lock-closed";
import HeroiconsMagnifyingGlass from "~icons/heroicons/magnifying-glass";
import HeroiconsMap from "~icons/heroicons/map";
import HeroiconsMapPin from "~icons/heroicons/map-pin";
import HeroiconsMegaphone from "~icons/heroicons/megaphone";
import HeroiconsMinus from "~icons/heroicons/minus";
import HeroiconsMinusCircle from "~icons/heroicons/minus-circle";
import HeroiconsMinusSmall from "~icons/heroicons/minus-small";
import HeroiconsMoon from "~icons/heroicons/moon";
import HeroiconsNewspaper from "~icons/heroicons/newspaper";
import HeroiconsNoSymbol from "~icons/heroicons/no-symbol";
import HeroiconsPaintBrush from "~icons/heroicons/paint-brush";
import HeroiconsPaperAirplane from "~icons/heroicons/paper-airplane";
import HeroiconsPause from "~icons/heroicons/pause";
import HeroiconsPencil from "~icons/heroicons/pencil";
import HeroiconsPencilSquare from "~icons/heroicons/pencil-square";
import HeroiconsPhone from "~icons/heroicons/phone";
import HeroiconsPhoto from "~icons/heroicons/photo";
import HeroiconsPlay from "~icons/heroicons/play";
import HeroiconsPlus from "~icons/heroicons/plus";
import HeroiconsPlusCircle from "~icons/heroicons/plus-circle";
import HeroiconsPlusSmall from "~icons/heroicons/plus-small";
import HeroiconsPuzzlePiece from "~icons/heroicons/puzzle-piece";
import HeroiconsQrCode from "~icons/heroicons/qr-code";
import HeroiconsQuestionMarkCircle from "~icons/heroicons/question-mark-circle";
import HeroiconsQueueList from "~icons/heroicons/queue-list";
import HeroiconsRectangleGroup from "~icons/heroicons/rectangle-group";
import HeroiconsRectangleStack from "~icons/heroicons/rectangle-stack";
import HeroiconsRocketLaunch from "~icons/heroicons/rocket-launch";
import HeroiconsServer from "~icons/heroicons/server";
import HeroiconsShare from "~icons/heroicons/share";
import HeroiconsShieldCheck from "~icons/heroicons/shield-check";
import HeroiconsShoppingCart from "~icons/heroicons/shopping-cart";
import HeroiconsSparkles from "~icons/heroicons/sparkles";
import HeroiconsSquares2x2 from "~icons/heroicons/squares-2x2";
import HeroiconsStar from "~icons/heroicons/star";
import HeroiconsStarSolid from "~icons/heroicons/star-solid";
import HeroiconsStopCircle from "~icons/heroicons/stop-circle";
import HeroiconsSun from "~icons/heroicons/sun";
import HeroiconsSwatch from "~icons/heroicons/swatch";
import HeroiconsTableCells from "~icons/heroicons/table-cells";
import HeroiconsTag from "~icons/heroicons/tag";
import HeroiconsTrash from "~icons/heroicons/trash";
import HeroiconsTrophy from "~icons/heroicons/trophy";
import HeroiconsUser from "~icons/heroicons/user";
import HeroiconsUserCircle from "~icons/heroicons/user-circle";
import HeroiconsUserCircleSolid from "~icons/heroicons/user-circle-solid";
import HeroiconsUserGroup from "~icons/heroicons/user-group";
import HeroiconsUserPlus from "~icons/heroicons/user-plus";
import HeroiconsUserSolid from "~icons/heroicons/user-solid";
import HeroiconsUsers from "~icons/heroicons/users";
import HeroiconsVideoCamera from "~icons/heroicons/video-camera";
import HeroiconsWindow from "~icons/heroicons/window";
import HeroiconsWrenchScrewdriver from "~icons/heroicons/wrench-screwdriver";
import HeroiconsXCircle from "~icons/heroicons/x-circle";
import HeroiconsXMark from "~icons/heroicons/x-mark";
import HeroiconsSolidCheck from "~icons/heroicons-solid/check";
import HeroiconsSolidExclamationCircle from "~icons/heroicons-solid/exclamation-circle";
import HeroiconsSolidHandThumbDown from "~icons/heroicons-solid/hand-thumb-down";
import HeroiconsSolidHandThumbUp from "~icons/heroicons-solid/hand-thumb-up";
import HeroiconsSolidPaperAirplane from "~icons/heroicons-solid/paper-airplane";
import HeroiconsSolidPhone from "~icons/heroicons-solid/phone";
import HeroiconsSolidQuestionMarkCircle from "~icons/heroicons-solid/question-mark-circle";
import HumbleiconsArrowSplit from "~icons/humbleicons/arrow-split";
import MaterialSymbolsArrowBack from "~icons/material-symbols/arrow-back";
import MaterialSymbolsBedOutline from "~icons/material-symbols/bed-outline";
import MaterialSymbolsCircle from "~icons/material-symbols/circle";
import MaterialSymbolsCircleOutline from "~icons/material-symbols/circle-outline";
import MaterialSymbolsFlowchartOutlineSharp from "~icons/material-symbols/flowchart-outline-sharp";
import MaterialSymbolsFolder from "~icons/material-symbols/folder";
import MaterialSymbolsImageOutline from "~icons/material-symbols/image-outline";
import MaterialSymbolsInsertChartOutline from "~icons/material-symbols/insert-chart-outline";
import MaterialSymbolsListAltAddOutline from "~icons/material-symbols/list-alt-add-outline";
import MaterialSymbolsMovieOutline from "~icons/material-symbols/movie-outline";
import MaterialSymbolsPictureAsPdfOutline from "~icons/material-symbols/picture-as-pdf-outline";
import MaterialSymbolsSquareFoot from "~icons/material-symbols/square-foot";
import MaterialSymbolsSsidChart from "~icons/material-symbols/ssid-chart";
import MaterialSymbolsStackedBarChart from "~icons/material-symbols/stacked-bar-chart";
import MaterialSymbolsTextFields from "~icons/material-symbols/text-fields";
import MaterialSymbolsLightBottomDrawer from "~icons/material-symbols-light/bottom-drawer";
import MaterialSymbolsLightCallToActionOutline from "~icons/material-symbols-light/call-to-action-outline";
import MaterialSymbolsLightDataTableOutline from "~icons/material-symbols-light/data-table-outline";
import MaterialSymbolsLightPaletteOutline from "~icons/material-symbols-light/palette-outline";
import MaterialSymbolsLightScrollableHeader from "~icons/material-symbols-light/scrollable-header";
import MdiApple from "~icons/mdi/apple";
import MdiArrowULeftTop from "~icons/mdi/arrow-u-left-top";
import MdiArrowURightTop from "~icons/mdi/arrow-u-right-top";
import MdiBathtubOutline from "~icons/mdi/bathtub-outline";
import MdiChartBoxOutline from "~icons/mdi/chart-box-outline";
import MdiClockPlusOutline from "~icons/mdi/clock-plus-outline";
import MdiCodeBraces from "~icons/mdi/code-braces";
import MdiContactsOutline from "~icons/mdi/contacts-outline";
import MdiDiscord from "~icons/mdi/discord";
import MdiEyedropperVariant from "~icons/mdi/eyedropper-variant";
import MdiFacebook from "~icons/mdi/facebook";
import MdiFolderMoveOutline from "~icons/mdi/folder-move-outline";
import MdiFormatAlignCenter from "~icons/mdi/format-align-center";
import MdiFormatAlignLeft from "~icons/mdi/format-align-left";
import MdiFormatAlignRight from "~icons/mdi/format-align-right";
import MdiFormatBold from "~icons/mdi/format-bold";
import MdiFormatItalic from "~icons/mdi/format-italic";
import MdiFormatStrikethrough from "~icons/mdi/format-strikethrough";
import MdiFormatUnderline from "~icons/mdi/format-underline";
import MdiHistory from "~icons/mdi/history";
import MdiHomeOutline from "~icons/mdi/home-outline";
import MdiInstagram from "~icons/mdi/instagram";
import MdiLinkedin from "~icons/mdi/linkedin";
import MdiRedoVariant from "~icons/mdi/redo-variant";
import MdiSnapchat from "~icons/mdi/snapchat";
import MdiSoundcloud from "~icons/mdi/soundcloud";
import MdiSpotify from "~icons/mdi/spotify";
import MdiTwitch from "~icons/mdi/twitch";
import MdiUndoVariant from "~icons/mdi/undo-variant";
import MdiWhatsapp from "~icons/mdi/whatsapp";
import MdiYoutube from "~icons/mdi/youtube";
import MingcuteDotsLine from "~icons/mingcute/dots-line";
import MingcuteSocialXLine from "~icons/mingcute/social-x-line";
import MingcuteThreadsLine from "~icons/mingcute/threads-line";
import MingcuteTiktokLine from "~icons/mingcute/tiktok-line";
import OcticonFilter16 from "~icons/octicon/filter-16";
import PhCalendar from "~icons/ph/calendar";
import PhCalendarCheck from "~icons/ph/calendar-check";
import PhCalendarDots from "~icons/ph/calendar-dots";
import PhCube from "~icons/ph/cube";
import DotsSixVertical from "~icons/ph/dots-six-vertical";
import PhImageBroken from "~icons/ph/image-broken";
import PhPathLight from "~icons/ph/path-light";
import PhSquare from "~icons/ph/square";
import RiDraftLine from "~icons/ri/draft-line";
import SolarMailboxOutline from "~icons/solar/mailbox-outline";
import TablerArrowBarToUp from "~icons/tabler/arrow-bar-to-up";
import TablerTemplate from "~icons/tabler/template";

type IconComponent = Component<SvelteHTMLElements["svg"]>;

export const iconMap: Record<string, IconComponent> = {
	"carbon/radio-button-checked": CarbonRadioButtonChecked,
	"cif/ad": CifAd,
	"cif/ae": CifAe,
	"cif/af": CifAf,
	"cif/al": CifAl,
	"cif/am": CifAm,
	"cif/ao": CifAo,
	"cif/ar": CifAr,
	"cif/at": CifAt,
	"cif/au": CifAu,
	"cif/az": CifAz,
	"cif/bd": CifBd,
	"cif/be": CifBe,
	"cif/bf": CifBf,
	"cif/bh": CifBh,
	"cif/bi": CifBi,
	"cif/bn": CifBn,
	"cif/bo": CifBo,
	"cif/br": CifBr,
	"cif/bt": CifBt,
	"cif/bw": CifBw,
	"cif/by": CifBy,
	"cif/bz": CifBz,
	"cif/ca": CifCa,
	"cif/cf": CifCf,
	"cif/ch": CifCh,
	"cif/cl": CifCl,
	"cif/cn": CifCn,
	"cif/co": CifCo,
	"cif/cr": CifCr,
	"cif/cu": CifCu,
	"cif/cv": CifCv,
	"cif/cy": CifCy,
	"cif/de": CifDe,
	"cif/dj": CifDj,
	"cif/dk": CifDk,
	"cif/do": CifDo,
	"cif/dz": CifDz,
	"cif/ec": CifEc,
	"cif/eg": CifEg,
	"cif/er": CifEr,
	"cif/es": CifEs,
	"cif/et": CifEt,
	"cif/fi": CifFi,
	"cif/fj": CifFj,
	"cif/fm": CifFm,
	"cif/fr": CifFr,
	"cif/ga": CifGa,
	"cif/gb": CifGb,
	"cif/ge": CifGe,
	"cif/gh": CifGh,
	"cif/gm": CifGm,
	"cif/gt": CifGt,
	"cif/gw": CifGw,
	"cif/gy": CifGy,
	"cif/hn": CifHn,
	"cif/ht": CifHt,
	"cif/id": CifId,
	"cif/ie": CifIe,
	"cif/il": CifIl,
	"cif/in": CifIn,
	"cif/iq": CifIq,
	"cif/is": CifIs,
	"cif/it": CifIt,
	"cif/jo": CifJo,
	"cif/jp": CifJp,
	"cif/ke": CifKe,
	"cif/kh": CifKh,
	"cif/ki": CifKi,
	"cif/km": CifKm,
	"cif/kw": CifKw,
	"cif/kz": CifKz,
	"cif/la": CifLa,
	"cif/li": CifLi,
	"cif/lk": CifLk,
	"cif/lr": CifLr,
	"cif/ls": CifLs,
	"cif/lu": CifLu,
	"cif/ma": CifMa,
	"cif/mc": CifMc,
	"cif/md": CifMd,
	"cif/me": CifMe,
	"cif/mg": CifMg,
	"cif/mh": CifMh,
	"cif/ml": CifMl,
	"cif/mn": CifMn,
	"cif/mr": CifMr,
	"cif/mt": CifMt,
	"cif/mv": CifMv,
	"cif/mw": CifMw,
	"cif/mx": CifMx,
	"cif/my": CifMy,
	"cif/mz": CifMz,
	"cif/na": CifNa,
	"cif/ne": CifNe,
	"cif/ng": CifNg,
	"cif/ni": CifNi,
	"cif/nl": CifNl,
	"cif/no": CifNo,
	"cif/np": CifNp,
	"cif/nr": CifNr,
	"cif/nu": CifNu,
	"cif/nz": CifNz,
	"cif/om": CifOm,
	"cif/pa": CifPa,
	"cif/pe": CifPe,
	"cif/pg": CifPg,
	"cif/ph": CifPh,
	"cif/pk": CifPk,
	"cif/pw": CifPw,
	"cif/py": CifPy,
	"cif/qa": CifQa,
	"cif/ru": CifRu,
	"cif/rw": CifRw,
	"cif/sa": CifSa,
	"cif/sb": CifSb,
	"cif/sc": CifSc,
	"cif/se": CifSe,
	"cif/sg": CifSg,
	"cif/sl": CifSl,
	"cif/sm": CifSm,
	"cif/so": CifSo,
	"cif/sr": CifSr,
	"cif/st": CifSt,
	"cif/sy": CifSy,
	"cif/sz": CifSz,
	"cif/td": CifTd,
	"cif/th": CifTh,
	"cif/tj": CifTj,
	"cif/tl": CifTl,
	"cif/tn": CifTn,
	"cif/to": CifTo,
	"cif/tv": CifTv,
	"cif/tz": CifTz,
	"cif/ua": CifUa,
	"cif/ug": CifUg,
	"cif/us": CifUs,
	"cif/uy": CifUy,
	"cif/uz": CifUz,
	"cif/va": CifVa,
	"cif/ve": CifVe,
	"cif/vn": CifVn,
	"cif/ws": CifWs,
	"cif/ye": CifYe,
	"cif/za": CifZa,
	"cif/zm": CifZm,
	"cif/zw": CifZw,
	"flowcode/filter-icon": FlowcodeFilterIcon,
	"flowcode/folder-solid": FlowcodeFolderSolid,
	"flowcode/qr-code": FlowcodeQrCode,
	"flowcode/return-to-start": FlowcodeReturnToStart,
	"flowcode/subfilter-icon": FlowcodeSubfilterIcon,
	"flowcode/text-component": FlowcodeTextComponent,
	"flowcode/custom-chart-size-1x1": FlowcodeCustomChartSize1x1,
	"flowcode/custom-chart-size-1x2": FlowcodeCustomChartSize1x2,
	"flowcode/custom-chart-size-1x3": FlowcodeCustomChartSize1x3,
	"flowcode/custom-chart-size-2x1": FlowcodeCustomChartSize2x1,
	"flowcode/custom-chart-size-2x2": FlowcodeCustomChartSize2x2,
	"flowcode/custom-chart-size-2x3": FlowcodeCustomChartSize2x3,
	"flowcode/six-dots-vertical": FlowcodeSixDotsVertical,
	"fluent/checkbox-checked-16-regular": FluentCheckboxChecked16Regular,
	"fluent/content-view-16-regular": FluentContentView16Regular,
	"gg/poll": GgPoll,
	"gridicons/grid": GridiconsGrid,
	"gridicons/heading-h1": GridiconsHeadingH1,
	"grommet-icons/select": GrommetIconsSelect,
	"grommet-icons/validate": GrommetIconsValidate,
	"heroicons-solid/check": HeroiconsSolidCheck,
	"heroicons-solid/exclamation-circle": HeroiconsSolidExclamationCircle,
	"heroicons-solid/hand-thumb-down": HeroiconsSolidHandThumbDown,
	"heroicons-solid/hand-thumb-up": HeroiconsSolidHandThumbUp,
	"heroicons-solid/paper-airplane": HeroiconsSolidPaperAirplane,
	"heroicons-solid/phone": HeroiconsSolidPhone,
	"heroicons-solid/question-mark-circle": HeroiconsSolidQuestionMarkCircle,
	"heroicons/adjustments-vertical": HeroiconsAdjustmentsVertical,
	"heroicons/archive-box": HeroiconsArchiveBox,
	"heroicons/arrow-down-tray": HeroiconsArrowDownTray,
	"heroicons/arrow-down": HeroiconsArrowDown,
	"heroicons/arrow-left-on-rectangle": HeroiconsArrowLeftOnRectangle,
	"heroicons/arrow-left": HeroiconsArrowLeft,
	"heroicons/arrow-long-left": HeroiconsArrowLongLeft,
	"heroicons/arrow-long-right": HeroiconsArrowLongRight,
	"heroicons/arrow-path": HeroiconsArrowPath,
	"heroicons/arrow-right-circle": HeroiconsArrowRightCircle,
	"heroicons/arrow-right-on-rectangle": HeroiconsArrowRightOnRectangle,
	"heroicons/arrow-right": HeroiconsArrowRight,
	"heroicons/arrow-top-right-on-square": HeroiconsArrowTopRightOnSquare,
	"heroicons/arrow-trending-down": HeroiconsArrowTrendingDown,
	"heroicons/arrow-trending-up": HeroiconsArrowTrendingUp,
	"heroicons/arrow-turn-down-right": HeroiconsArrowTurnDownRight,
	"heroicons/arrow-up-tray": HeroiconsArrowUpTray,
	"heroicons/arrow-up": HeroiconsArrowUp,
	"heroicons/bars-2": HeroiconsBars2,
	"heroicons/bars-3-bottom-left": HeroiconsBars3BottomLeft,
	"heroicons/bars-3": HeroiconsBars3,
	"heroicons/beaker": HeroiconsBeaker,
	"heroicons/bell": HeroiconsBell,
	"heroicons/bolt": HeroiconsBolt,
	"heroicons/book-open": HeroiconsBookOpen,
	"heroicons/bookmark-square": HeroiconsBookmarkSquare,
	"heroicons/building-office-2": HeroiconsBuildingOffice2,
	"heroicons/building-storefront": HeroiconsBuildingStorefront,
	"heroicons/calculator": HeroiconsCalculator,
	"heroicons/calendar-days": HeroiconsCalendarDays,
	"heroicons/camera": HeroiconsCamera,
	"heroicons/chart-bar-square": HeroiconsChartBarSquare,
	"heroicons/chart-bar": HeroiconsChartBar,
	"heroicons/chat-bubble-left-ellipsis": HeroiconsChatBubbleLeftEllipsis,
	"heroicons/chat-bubble-left-right": HeroiconsChatBubbleLeftRight,
	"heroicons/check-circle": HeroiconsCheckCircle,
	"heroicons/check": HeroiconsCheck,
	"heroicons/chevron-double-left": HeroiconsChevronDoubleLeft,
	"heroicons/chevron-double-right": HeroiconsChevronDoubleRight,
	"heroicons/chevron-down": HeroiconsChevronDown,
	"heroicons/chevron-left": HeroiconsChevronLeft,
	"heroicons/chevron-right": HeroiconsChevronRight,
	"heroicons/chevron-up-down": HeroiconsChevronUpDown,
	"heroicons/chevron-up": HeroiconsChevronUp,
	"heroicons/circle-stack": HeroiconsCircleStack,
	"heroicons/clipboard-document-check": HeroiconsClipboardDocumentCheck,
	"heroicons/clipboard-document-list": HeroiconsClipboardDocumentList,
	"heroicons/clipboard-document": HeroiconsClipboardDocument,
	"heroicons/clipboard": HeroiconsClipboard,
	"heroicons/clock": HeroiconsClock,
	"heroicons/cloud-arrow-up": HeroiconsCloudArrowUp,
	"heroicons/cloud": HeroiconsCloud,
	"heroicons/code-bracket-square": HeroiconsCodeBracketSquare,
	"heroicons/code-bracket": HeroiconsCodeBracket,
	"heroicons/cog-6-tooth": HeroiconsCog6Tooth,
	"heroicons/cog-8-tooth-solid": HeroiconsCog8ToothSolid,
	"heroicons/credit-card": HeroiconsCreditCard,
	"heroicons/currency-dollar": HeroiconsCurrencyDollar,
	"heroicons/cursor-arrow-rays-solid": HeroiconsCursorArrowRaysSolid,
	"heroicons/cursor-arrow-ripple-solid": HeroiconsCursorArrowRippleSolid,
	"heroicons/cursor-arrow-ripple": HeroiconsCursorArrowRipple,
	"heroicons/device-phone-mobile": HeroiconsDevicePhoneMobile,
	"heroicons/document-duplicate": HeroiconsDocumentDuplicate,
	"heroicons/document-plus": HeroiconsDocumentPlus,
	"heroicons/document-text": HeroiconsDocumentText,
	"heroicons/document": HeroiconsDocument,
	"heroicons/ellipsis-horizontal": HeroiconsEllipsisHorizontal,
	"heroicons/ellipsis-vertical": HeroiconsEllipsisVertical,
	"heroicons/envelope": HeroiconsEnvelope,
	"heroicons/equals": HeroiconsEquals,
	"heroicons/exclamation-circle": HeroiconsExclamationCircle,
	"heroicons/exclamation-triangle": HeroiconsExclamationTriangle,
	"heroicons/eye-slash": HeroiconsEyeSlash,
	"heroicons/eye": HeroiconsEye,
	"heroicons/folder-plus": HeroiconsFolderPlus,
	"heroicons/folder": HeroiconsFolder,
	"heroicons/globe-alt": HeroiconsGlobeAlt,
	"heroicons/globe-americas": HeroiconsGlobeAmericas,
	"heroicons/hand-raised": HeroiconsHandRaised,
	"heroicons/hashtag": HeroiconsHashtag,
	"heroicons/heart-solid": HeroiconsHeartSolid,
	"heroicons/heart": HeroiconsHeart,
	"heroicons/home": HeroiconsHome,
	"heroicons/identification": HeroiconsIdentification,
	"heroicons/information-circle": HeroiconsInformationCircle,
	"heroicons/key": HeroiconsKey,
	"heroicons/light-bulb": HeroiconsLightBulb,
	"heroicons/link": HeroiconsLink,
	"heroicons/list-bullet": HeroiconsListBullet,
	"heroicons/lock-closed": HeroiconsLockClosed,
	"heroicons/magnifying-glass": HeroiconsMagnifyingGlass,
	"heroicons/map-pin": HeroiconsMapPin,
	"heroicons/map": HeroiconsMap,
	"heroicons/megaphone": HeroiconsMegaphone,
	"heroicons/minus-circle": HeroiconsMinusCircle,
	"heroicons/minus-small": HeroiconsMinusSmall,
	"heroicons/minus": HeroiconsMinus,
	"heroicons/moon": HeroiconsMoon,
	"heroicons/newspaper": HeroiconsNewspaper,
	"heroicons/no-symbol": HeroiconsNoSymbol,
	"heroicons/paint-brush": HeroiconsPaintBrush,
	"heroicons/paper-airplane": HeroiconsPaperAirplane,
	"heroicons/pause": HeroiconsPause,
	"heroicons/pencil-square": HeroiconsPencilSquare,
	"heroicons/pencil": HeroiconsPencil,
	"heroicons/phone": HeroiconsPhone,
	"heroicons/photo": HeroiconsPhoto,
	"heroicons/play": HeroiconsPlay,
	"heroicons/plus-circle": HeroiconsPlusCircle,
	"heroicons/plus-small": HeroiconsPlusSmall,
	"heroicons/plus": HeroiconsPlus,
	"heroicons/puzzle-piece": HeroiconsPuzzlePiece,
	"heroicons/qr-code": HeroiconsQrCode,
	"heroicons/question-mark-circle": HeroiconsQuestionMarkCircle,
	"heroicons/queue-list": HeroiconsQueueList,
	"heroicons/rectangle-group": HeroiconsRectangleGroup,
	"heroicons/rectangle-stack": HeroiconsRectangleStack,
	"heroicons/rocket-launch": HeroiconsRocketLaunch,
	"heroicons/server": HeroiconsServer,
	"heroicons/share": HeroiconsShare,
	"heroicons/shield-check": HeroiconsShieldCheck,
	"heroicons/shopping-cart": HeroiconsShoppingCart,
	"heroicons/sparkles": HeroiconsSparkles,
	"heroicons/squares-2x2": HeroiconsSquares2x2,
	"heroicons/star-solid": HeroiconsStarSolid,
	"heroicons/star": HeroiconsStar,
	"heroicons/stop-circle": HeroiconsStopCircle,
	"heroicons/sun": HeroiconsSun,
	"heroicons/swatch": HeroiconsSwatch,
	"heroicons/table-cells": HeroiconsTableCells,
	"heroicons/tag": HeroiconsTag,
	"heroicons/trash": HeroiconsTrash,
	"heroicons/trophy": HeroiconsTrophy,
	"heroicons/user-circle-solid": HeroiconsUserCircleSolid,
	"heroicons/user-circle": HeroiconsUserCircle,
	"heroicons/user-group": HeroiconsUserGroup,
	"heroicons/user-plus": HeroiconsUserPlus,
	"heroicons/user-solid": HeroiconsUserSolid,
	"heroicons/user": HeroiconsUser,
	"heroicons/users": HeroiconsUsers,
	"heroicons/video-camera": HeroiconsVideoCamera,
	"heroicons/window": HeroiconsWindow,
	"heroicons/wrench-screwdriver": HeroiconsWrenchScrewdriver,
	"heroicons/x-circle": HeroiconsXCircle,
	"heroicons/x-mark": HeroiconsXMark,
	"humbleicons/arrow-split": HumbleiconsArrowSplit,
	"material-symbols-light/bottom-drawer": MaterialSymbolsLightBottomDrawer,
	"material-symbols-light/call-to-action-outline": MaterialSymbolsLightCallToActionOutline,
	"material-symbols-light/data-table-outline": MaterialSymbolsLightDataTableOutline,
	"material-symbols-light/palette-outline": MaterialSymbolsLightPaletteOutline,
	"material-symbols-light/scrollable-header": MaterialSymbolsLightScrollableHeader,
	"material-symbols/arrow-back": MaterialSymbolsArrowBack,
	"material-symbols/bed-outline": MaterialSymbolsBedOutline,
	"material-symbols/circle-outline": MaterialSymbolsCircleOutline,
	"material-symbols/circle": MaterialSymbolsCircle,
	"material-symbols/flowchart-outline-sharp": MaterialSymbolsFlowchartOutlineSharp,
	"material-symbols/folder": MaterialSymbolsFolder,
	"material-symbols/image-outline": MaterialSymbolsImageOutline,
	"material-symbols/insert-chart-outline": MaterialSymbolsInsertChartOutline,
	"material-symbols/list-alt-add-outline": MaterialSymbolsListAltAddOutline,
	"material-symbols/movie-outline": MaterialSymbolsMovieOutline,
	"material-symbols/picture-as-pdf-outline": MaterialSymbolsPictureAsPdfOutline,
	"material-symbols/square-foot": MaterialSymbolsSquareFoot,
	"material-symbols/ssid-chart": MaterialSymbolsSsidChart,
	"material-symbols/stacked-bar-chart": MaterialSymbolsStackedBarChart,
	"material-symbols/text-fields": MaterialSymbolsTextFields,
	"mdi/apple": MdiApple,
	"mdi/arrow-u-left-top": MdiArrowULeftTop,
	"mdi/arrow-u-right-top": MdiArrowURightTop,
	"mdi/bathtub-outline": MdiBathtubOutline,
	"mdi/chart-box-outline": MdiChartBoxOutline,
	"mdi/clock-plus-outline": MdiClockPlusOutline,
	"mdi/code-braces": MdiCodeBraces,
	"mdi/contacts-outline": MdiContactsOutline,
	"mdi/discord": MdiDiscord,
	"mdi/eyedropper-variant": MdiEyedropperVariant,
	"mdi/facebook": MdiFacebook,
	"mdi/folder-move-outline": MdiFolderMoveOutline,
	"mdi/format-align-center": MdiFormatAlignCenter,
	"mdi/format-align-left": MdiFormatAlignLeft,
	"mdi/format-align-right": MdiFormatAlignRight,
	"mdi/format-bold": MdiFormatBold,
	"mdi/format-italic": MdiFormatItalic,
	"mdi/format-strikethrough": MdiFormatStrikethrough,
	"mdi/format-underline": MdiFormatUnderline,
	"mdi/history": MdiHistory,
	"mdi/home-outline": MdiHomeOutline,
	"mdi/instagram": MdiInstagram,
	"mdi/linkedin": MdiLinkedin,
	"mdi/redo-variant": MdiRedoVariant,
	"mdi/snapchat": MdiSnapchat,
	"mdi/soundcloud": MdiSoundcloud,
	"mdi/spotify": MdiSpotify,
	"mdi/twitch": MdiTwitch,
	"mdi/undo-variant": MdiUndoVariant,
	"mdi/whatsapp": MdiWhatsapp,
	"mdi/youtube": MdiYoutube,
	"mingcute/dots-line": MingcuteDotsLine,
	"mingcute/social-x-line": MingcuteSocialXLine,
	"mingcute/threads-line": MingcuteThreadsLine,
	"mingcute/tiktok-line": MingcuteTiktokLine,
	"octicon/filter-16": OcticonFilter16,
	"ph/calendar-check": PhCalendarCheck,
	"ph/calendar-dots": PhCalendarDots,
	"ph/calendar": PhCalendar,
	"ph/cube": PhCube,
	"ph/dots-six-vertical": DotsSixVertical,
	"ph/image-broken": PhImageBroken,
	"ph/path-light": PhPathLight,
	"ph/square": PhSquare,
	"ri/draft-line": RiDraftLine,
	"solar/mailbox-outline": SolarMailboxOutline,
	"tabler/arrow-bar-to-up": TablerArrowBarToUp,
	"tabler/template": TablerTemplate,
};
